import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: 'ui-figure-text',
})
export class UiFigureTextDirective {
  @HostBinding('class') elClass = 'ui-figure-text';
}
